import moment from "moment"; 

export const dateFormat = (date: Date) => {
  if (date === null || date === undefined) return null
  return moment(date).format("YYYY-MM-DD");
};
